<template>
  <LoadingItem v-if="loading" />
  <div class="member-wrap">
    <div class="list-header">
      <div class="list-nav">
        <div class="nav-left">
          <button class="nav-btn" @click="this.$refreshPage()">새로고침</button>
          <span style="margin-right: 20px">
            전체회원수 :
            <span style="color: red">
              {{ $addCommas(memberTotal.allUserCount) }}명
            </span>
          </span>
          <span style="margin-right: 20px">
            로그인중회원 :
            <span style="color: red">
              {{ $addCommas(memberTotal.loginUserCount) }}명
            </span>
          </span>
          <span style="margin-right: 20px">
            당일로그인회원 :
            <span style="color: red">
              {{ $addCommas(memberTotal.todayLoginUserCount) }}명
            </span>
          </span>
          <span>
            회원가입신청 :
            <span style="color: red">
              {{ $addCommas(memberTotal.signupUserCount) }}명
            </span>
          </span>
        </div>
        <div class="nav-right">
          <span>
            총보유머니 :
            <span style="color: red; margin-right: 30px">
              {{ $addCommas(memberTotal.money) }}
            </span>
            <span style="margin-right: 5px">
              총보유포인트:
              <span style="color: red">
                {{ $addCommas(memberTotal.point) }}
              </span>
            </span>
          </span>
        </div>
      </div>
      <!-- list-nav -->
      <div class="list-set">
        <div class="left-set">
          <select v-model="searchQuery.size" @change="getList(1)">
            <option value="30">30개</option>
            <option value="50">50개</option>
            <option value="100">100개</option>
            <option value="200">200개</option>
          </select>
          <select v-model="searchQuery.sort" @change="getList(1)">
            <option selected="selected" value="login_datetime">
              최근접속순
            </option>
            <option value="username">가나다순</option>
            <option value="money">보유머니순</option>
            <option value="point">보유포인트순</option>
            <option value="signup_datetime">가입일순</option>
            <option value="login_ip">IP순</option>
          </select>
          <span style="margin-left: 20px">아이디/이름</span>
          <select v-model="searchQuery.searchType">
            <option selected="selected" value="name">이름</option>
            <option value="username">아이디</option>
            <option value="level">레벨</option>
          </select>
          <input
            type="text"
            @keydown.enter="getList(1)"
            v-model="searchQuery.searchText"
            style="width: 80px"
          />
          <span style="margin-left: 7px">날짜</span>
          <DatePic
            v-model:value="date"
            format="YYYY-MM-DD"
            value-type="format"
          />
          <input
            type="button"
            value="검색"
            @click="getList(1)"
            style="margin-left: 7px"
          />
        </div>
        <div class="date-bothSide">
          <input
            type="button"
            :value="$moment(date).subtract(1, 'days').format('YYYY-MM-DD')"
            @click="searchDate($event.target.value)"
            style="margin-left: 20px"
          />
          <span style="margin: 0 3px">{{ date }}</span>
          <input
            type="button"
            :value="$moment(date).add(1, 'days').format('YYYY-MM-DD')"
            @click="searchDate($event.target.value)"
          />
        </div>
      </div>
      <!-- list-set -->
    </div>
    <!-- list-header -->
    <div class="member-list-wrap">
      <table class="member-table table-normal">
        <tr>
          <th v-for="(item, i) in listTh" :key="i">{{ item }}</th>
        </tr>
        <tr v-for="(item, i) in list" :key="i">
          <td style="color: blue; font-weight: bold">
            {{ item.username }}
          </td>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.login_domain }}
          </td>
          <td>
            {{ item.login_ip }}
          </td>
          <td>
            {{ item.money != 0 ? $addCommas(item.money) : " " }}
          </td>
          <td>
            {{ item.point != 0 ? $addCommas(item.point) : " " }}
          </td>
          <td>
            {{
              item.deposit_amount != 0 ? $addCommas(item.deposit_amount) : " "
            }}
          </td>
          <td>
            {{
              item.withdrawal_amount != 0
                ? $addCommas(item.withdrawal_amount)
                : " "
            }}
          </td>
          <td style="color: #ae00ff">
            {{
              item.total_deposit_amount != 0
                ? $addCommas(item.total_deposit_amount)
                : " "
            }}
          </td>
          <td style="color: #ae00ff">
            {{
              item.total_withdrawal_amount != 0
                ? $addCommas(item.total_withdrawal_amount)
                : " "
            }}
          </td>
          <td>
            {{
              item.money_bet_amount != 0
                ? $addCommas(item.money_bet_amount)
                : " "
            }}
          </td>
          <td>
            {{
              item.point_bet_amount != 0
                ? $addCommas(item.point_bet_amount)
                : " "
            }}
          </td>
          <td>
            {{ item.win_amount != 0 ? $addCommas(item.win_amount) : " " }}
          </td>
          <td>
            {{
              item.money_bet_amount + item.point_bet_amount - item.win_amount ==
              0
                ? ""
                : $addCommas(
                    item.money_bet_amount +
                      item.point_bet_amount -
                      item.win_amount
                  )
            }}
          </td>
          <td>
            <span v-if="item.account_status === 0">요청</span>
            <span v-if="item.account_status === 1">대기</span>
            <span v-if="item.account_status === 2">정상</span>
            <span v-if="item.account_status === 3">불가</span>
          </td>
          <td>
            {{ item.login_status == 0 ? "OFF" : "ON" }}
          </td>
        </tr>
        <tr style="background-color: #f3caac" v-if="list.length > 0">
          <td colspan="5"></td>
          <td>
            {{ $addCommas(total.money == 0 ? "" : $addCommas(total.money)) }}
          </td>
          <td>
            {{ $addCommas(total.point == 0 ? "" : $addCommas(total.point)) }}
          </td>
          <td>
            {{ total.deposit == 0 ? "" : $addCommas(total.deposit) }}
          </td>
          <td>
            {{ total.withdrawal == 0 ? "" : $addCommas(total.withdrawal) }}
          </td>
          <td style="color: #ae00ff">
            {{ total.totalDeposit == 0 ? "" : $addCommas(total.totalDeposit) }}
          </td>
          <td style="color: #ae00ff">
            {{
              total.totalWithdrawal == 0
                ? ""
                : $addCommas(total.totalWithdrawal)
            }}
          </td>
          <td style="color: #ae00ff">
            {{ total.moneyBet == 0 ? "" : $addCommas(total.moneyBet) }}
          </td>
          <td style="color: #ae00ff">
            {{ total.pointBet == 0 ? "" : $addCommas(total.pointBet) }}
          </td>
          <td style="color: #ae00ff">
            {{ total.winAmount == 0 ? "" : $addCommas(total.winAmount) }}
          </td>
          <td style="color: #ae00ff">
            {{ total.profitLoss == 0 ? "" : $addCommas(total.profitLoss) }}
          </td>
          <td colspan="4"></td>
        </tr>
      </table>
      <div class="pagination">
        <v-pagination
          v-model="searchQuery.page"
          :pages="totalPage"
          :range-size="1"
          active-color="#DCEDFF"
          @update:modelValue="getList()"
        />
      </div>
    </div>
    <!-- member-list-wrap -->
  </div>
  <!-- member-list-wrap -->
</template>
<script>
export default {
  data() {
    return {
      listTh: [
        "아이디",
        "이름",
        "접속도메인",
        "접속IP",
        "보유머니",
        "보유포인트",
        "당일충전",
        "당일환전",
        "누적충전",
        "누적환전",
        "머니배팅",
        "포인트배팅",
        "당첨금액",
        "손익금액",
        "상태",
        "접속",
      ],
      list: [],
      memberTotal: {},
      loading: false,
      date: this.$moment().format("YYYY-MM-DD"),
      totalPage: "",
      searchQuery: {
        page: 1,
        size: 50,
        sort: "login_datetime",
        order: "desc",
        searchType: "name",
        searchText: "",
      },
      total: {
        money: 0,
        point: 0,
        deposit: 0,
        withdrawal: 0,
        totalDeposit: 0,
        totalWithdrawal: 0,
        moneyBet: 0,
        pointBet: 0,
        profitLoss: 0,
        winAmount: 0,
      },
    };
  },
  mounted() {
    this.getList();
    this.getMemberTotal();
  },
  methods: {
    //회원목록
    getList(page) {
      //order값 수정
      if (
        this.searchQuery.sort == "username" ||
        this.searchQuery.sort == "signup_datetime" ||
        this.searchQuery.sort == "login_ip"
      ) {
        this.searchQuery.order = "asc";
      } else this.searchQuery.order = "desc";
      this.totalInit();

      if (page) {
        this.searchQuery.page = page;
      }

      //요청
      this.loading = true;
      this.$axios
        .get(
          `/user?searchDate=${this.date}&${this.$qs.stringify(
            this.searchQuery
          )}`
        )
        .then((res) => {
          if (res) {
            this.list = res.data.data;
            this.totalPage = res.data.totalPage;
            this.totalCalc();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //상단 토탈
    getMemberTotal() {
      this.$axios.get("/user/summary").then((res) => {
        if (res) {
          this.memberTotal = res.data;
        }
      });
    },
    //날짜검색
    searchDate(e) {
      this.date = e;
      this.getList(1);
    },
    //토탈 계산
    totalCalc() {
      this.list.forEach((x) => {
        this.total.money += x.money;
        this.total.point += x.point;
        this.total.deposit += x.deposit_amount;
        this.total.withdrawal += x.withdrawal_amount;
        this.total.totalDeposit += x.total_deposit_amount;
        this.total.totalWithdrawal += x.total_withdrawal_amount;
        this.total.moneyBet += x.money_bet_amount;
        this.total.pointBet += x.point_bet_amount;
        this.total.winAmount += x.win_amount;
        this.profitLoss =
          this.total.moneyBet + this.total.pointBet - this.total.winAmount;
      });
    },
    //토탈 초기화
    totalInit() {
      for (let e in this.total) {
        this.total[e] = 0;
      }
    },
  },
};
</script>
